import { ReactComponent as StarIcon } from "../../../assets/icons/star.svg";
import { ReactComponent as EmptyStarIcon } from "../../../assets/icons/empty-star.svg";
import { ReactComponent as HalfStarIcon } from "../../../assets/icons/half-star.svg";
import { twMerge } from "tailwind-merge";

export function Rating({
  value,
  showMax = true,
  showCount = true,
  onChange,
  showRemainingStars = true,
  contentClassName = "",
  halfStarClassName = "",
}: {
  value: number;
  showMax?: boolean;
  showCount?: boolean;
  onChange?: (value: number) => void;
  showRemainingStars?: boolean;
  contentClassName?: string;
  halfStarClassName?: string;
}) {
  let totalFullStars = Math.floor(value);
  const hasHalfStar = value - totalFullStars > 0;
  if (totalFullStars >= 5) {
    totalFullStars = 5 - (hasHalfStar ? 1 : 0);
  }
  const remainingEmptyStars = 5 - (totalFullStars + (hasHalfStar ? 1 : 0));
  const totalFilledStars = totalFullStars + (hasHalfStar ? 1 : 0);

  return (
    <div className="flex items-center">

      <div className={twMerge("content ml-3 star-container flex items-center gap-1", contentClassName)}>
        {Array.from({ length: totalFullStars }).map((_, index) => onChange ? (
          <button key={index} onClick={() => onChange(index + 1)}>
            <StarIcon key={index} className="w-5 h-5" />
          </button>
        ) : (
          <StarIcon key={index} className="w-5 h-5" />
        ))}
        {hasHalfStar && <HalfStarIcon className={twMerge("w-5 h-5", halfStarClassName)} />}
        {showRemainingStars && (
          <>
            {Array.from({ length: remainingEmptyStars }).map((_, index) => onChange ? (
              <button key={index} onClick={() => onChange(totalFilledStars + index + 1)}>
                <EmptyStarIcon key={index} className="w-5 h-5" />
              </button>
            ) : (
              <EmptyStarIcon key={index} className="w-5 h-5" />
            ))}
          </>
        )}
      </div>
      {showCount && (
        <div className="text-[#343434] text-base">
          {value}
          {showMax ? "/5" : ""}
        </div>
      )}
    </div>
  );
}
